import { AnimatePresence, useReducedMotion } from 'motion/react';
import * as m from 'motion/react-m';
import { useIntl } from 'react-intl';

import type { VoiceSessionState } from '../../../contracts/voice-protocol';
import type { VoiceConnectionStatus } from '../store/useVoiceAssistantStore';
import { statusLabel } from './voiceAssistantPanelStatus';

interface VoiceAssistantTurnStatusProps {
  connection: VoiceConnectionStatus;
  sessionState: VoiceSessionState;
  greetingComplete: boolean;
}

/** Cross-fades turn ownership so startup never flashes a false “Listening” state. */
export function VoiceAssistantTurnStatus({
  connection,
  sessionState,
  greetingComplete,
}: VoiceAssistantTurnStatusProps) {
  const intl = useIntl();
  const reduceMotion = useReducedMotion();
  const label = statusLabel(intl, connection, sessionState, greetingComplete);

  return (
    <span
      className="block h-4 overflow-hidden text-[10px] text-text-secondary"
      aria-live="polite"
      data-testid="voice-assistant-turn-status"
    >
      <AnimatePresence mode="wait" initial={false}>
        <m.span
          key={label}
          className="block truncate"
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 3 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: -3 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          {label}
        </m.span>
      </AnimatePresence>
    </span>
  );
}
